<div class="section section-newsletter" *ngIf="showNewsletter">

  <div class="container-section">

    <p class="alternate-heading-subline">{{ 'Do you want to stay informed? Then hit the subscribe button below!' | translate }}</p>

    <div class="row">
      <div class="col-12 text-center">
        <button type="button" (click)="openNewsletterModal()" class="btn btn-special btn-primary">
          {{ 'Subscribe to newsletter' | translate}}
        </button>
      </div>
    </div>

  </div>

</div>
